import React, { useEffect } from 'react';
import './Overview.css';
import heroVideo from '../Assets/overview vid.mp4';
import image1 from '../Assets/over2.jpg';
import image2 from '../Assets/over3.png';
import image3 from '../Assets/over4.jpg';
import galleryImage1 from '../Assets/over.jpg';
import galleryImage2 from '../Assets/iso.png';
import galleryImage3 from '../Assets/over5.jpg';
import galleryImage4 from '../Assets/vision.jpg';
import { useNavigate } from 'react-router-dom';
// Client image imports
import client1 from '../Assets/ibm.jpg';
import client2 from '../Assets/ing.jpg';
import client3 from '../Assets/emer.jpg';
import client4 from '../Assets/delta.jpg';
import client5 from '../Assets/daifuku.jpg';
import client6 from '../Assets/ambe.jpg';
import client7 from '../Assets/amara.jpg';
import client8 from '../Assets/wipro.jpg';
import client9 from '../Assets/thought.jpg';
import client10 from '../Assets/swan.jpg';
import client11 from '../Assets/mahindra.jpg';
import client12 from '../Assets/lineage.jpg';
import client13 from '../Assets/AD_Logo_AWP-1.png';
import client14 from '../Assets/ti_stk_2c_pos_rgb_png.png';
import client15 from '../Assets/wavecom.png';
import client16 from '../Assets/NXP-Logo.svg.png';
import client17 from '../Assets/Telit_2015_logo.png';
import client18 from '../Assets/Walsin.jpg';
import client19 from '../Assets/dat.png';
import client20 from '../Assets/tgs.jpeg';
import client21 from '../Assets/TSNPDCL.jpg';
import client22 from '../Assets/ecil.jpeg';
import client23 from '../Assets/RailTel-Preview.png';
import client24 from '../Assets/apepdcl.jpeg';
import client25 from '../Assets/tang.png';
import client26 from '../Assets/sccl.jpeg';
import client27 from '../Assets/mahaaa.png';
import client28 from '../Assets/rail.png';
import client29 from '../Assets/apsfl.png';
import client30 from '../Assets/tata.png';

import client31 from '../Assets/hatsun.png';
import client32 from '../Assets/silicon.png';
import client33 from '../Assets/Quectel.jpg';




const Overview = () => {
    const navigate = useNavigate();

    const handleExploreClick = () => {
        navigate('/explore');
    };

    useEffect(() => {
        const cards = document.querySelectorAll('.content-card, .gallery-card');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-on-scroll', 'animated');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.2 }
        );

        cards.forEach((card) => observer.observe(card));

        return () => {
            cards.forEach((card) => observer.unobserve(card));
        };
    }, []);

    // Client data grouped by category
    const privateClients = [
        { src: client1, alt: 'IBM' },
        { src: client2, alt: 'ING' },
        { src: client3, alt: 'Emer' },
        { src: client4, alt: 'Delta' },
        { src: client6, alt: 'Ambe' },
        { src: client7, alt: 'Amara' },
        { src: client8, alt: 'Wipro' },
        { src: client9, alt: 'Thought' },
        { src: client10, alt: 'Swan' },
        { src: client11, alt: 'Mahindra' },
        { src: client12, alt: 'Lineage' },
        { src: client31, alt: 'hatsun' },
    ];
    const governmentClients = [
        { src: client20, alt: 'tgs' },
        { src: client21, alt: 'tgs' },
        { src: client22, alt: 'ecil' },
        { src: client23, alt: 'rail' },
       
        { src: client24, alt: 'apepdcl' },
        { src: client25, alt: 'tang' },
        { src: client26, alt: 'sccl' },
        { src: client27, alt: 'mahaaa' },
         { src: client28, alt: 'rail' },
         { src: client29, alt: 'apsfl' },
         { src: client30, alt: 'tata' },
         





    ];
    const internationalClients = [
        { src: client5, alt: 'Daifuku' },
        { src: client19, alt: 'dat' },

    ];
    const chipsetClients = [
        { src: client13, alt: 'AD' },
        { src: client14, alt: 'TI' },
        { src: client15, alt: 'Wavecom' },
        { src: client16, alt: 'NXP' },
        { src: client17, alt: 'Telit' },
        { src: client18, alt: 'Walsin' },
        { src: client32, alt: 'silicon' },
                { src: client33, alt: 'Quectel' },

    ];

    return (
        <div className="overview">
            {/* Hero Section with Video Background */}
            <div className="video-container">
                <video className="background-video" autoPlay muted loop>
                    <source src={heroVideo} type="video/webm" />
                    Your browser does not support the video tag.
                </video>
                <div className="hero-section">
                    <div className="hero-content">
                        <h1>Innovative IoT for Tomorrow's World</h1>
                        <p>Redefining industries with end-to-end IoT solutions for smarter decisions.</p>
                      
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="cards-background">
                <div className="content-section">
                    <div className="content-card">
                        <img src={image1} alt="Value Proposition" />
                        <h2>Our Value Proposition</h2>
                        <p>IoT CoE<br />Consulting</p>
                    </div>
                    <div className="content-card">
                        <img src={image2} alt="Customer Benefits" />
                        <h2>Benefits Derived to Customers from our Products & Solutions</h2>
                        <p>“One stop shop” for end-to-end solutions using disruptive technologies and methods.</p>
                        <p>Real Time Alerts on Events, Track and Trace the Assets, Pilferage Detection & Alerts</p>
                    </div>
                    <div className="content-card">
                        <img src={image3} alt="Key Activities" />
                        <h2>Key Activities</h2>
                        <p>In-house Design & Development of hardware and software...</p>
                        <p>Quick customization, Solutions and Technical support.</p>
                    </div>
                </div>

                {/* Gallery Section */}
                <div className="gallery-section">
                    <div className="gallery-card">
                        <h1>Certifications & Methodologies</h1>
                        <div className="combined-images">
                            <div className="image-text-pair">
                                <img src={galleryImage1} alt="ISO 14001:2015" className="gallery-image" />
                                <p>ISO 14001:2015</p>
                            </div>
                            <div className="image-text-pair">
                                <img src={galleryImage2} alt="ISO 9001:2015" className="gallery-image" />
                                <p>ISO 9001:2015</p>
                            </div>
                        </div>
                    </div>
                    <div className="content-card">
                        <img src={galleryImage3} alt="Mission" />
                        <h2>Mission</h2>
                        <p>
                            To become a market leader in providing innovative real-time IOT & IT BASED Solutions In Energy, Telecom, Healthcare, Aqua, Automotive, Smart Cities and Green infra with motivated Team.
                        </p>
                    </div>
                    <div className="content-card">
                        <img src={galleryImage4} alt="Vision" />
                        <h2>Vision</h2>
                        <p>Empowering a smarter, greener world through cutting-edge AI-driven IoT, IT, and analytics to delivers transformative infrastructure across industries, enabling sustainable growth, future-ready innovation, and trusted partnerships that shape tomorrow.</p>
                    </div>
                </div>
            </div>

            {/* Clients Section */}
            <div className="clients-section" style={{ padding: '40px 20px', backgroundColor: 'white' }}>
                <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Our Clients</h2>

                {/* Private Clients Carousel */}
                <div className="clients-category">
                    <h3>Clients in Private Sector</h3>
                    <div className="clients-carousel">
                        <div className="clients-track">
                            {privateClients.map((client, index) => (
                                <img
                                    key={`private-${index}`}
                                    src={client.src}
                                    alt={client.alt}
                                    className="client-logo"
                                />
                            ))}
                            {privateClients.map((client, index) => (
                                <img
                                    key={`private-dup-${index}`}
                                    src={client.src}
                                    alt={client.alt}
                                    className="client-logo"
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* Government Clients Carousel */}
                <div className="clients-category">
                    <h3>Government Clients</h3>
                    <div className="clients-carousel">
                        <div className="clients-track">
                            {governmentClients.map((client, index) => (
                                <img
                                    key={`government-${index}`}
                                    src={client.src}
                                    alt={client.alt}
                                    className="client-logo"
                                />
                            ))}
                            {governmentClients.map((client, index) => (
                                <img
                                    key={`government-dup-${index}`}
                                    src={client.src}
                                    alt={client.alt}
                                    className="client-logo"
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* International Clients (Static) */}
                <div className="clients-category">
                    <h3>International Clients</h3>
                    <div className="clients-carousel static-carousel">
                        <div className="clients-track static-track">
                            {internationalClients.map((client, index) => (
                                <img
                                    key={`international-${index}`}
                                    src={client.src}
                                    alt={client.alt}
                                    className="client-logo"
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* Chipset Providers Carousel */}
                <div className="clients-category">
                    <h3>Chipset Providers</h3>
                    <div className="clients-carousel">
                        <div className="clients-track">
                            {chipsetClients.map((client, index) => (
                                <img
                                    key={`chipset-${index}`}
                                    src={client.src}
                                    alt={client.alt}
                                    className="client-logo"
                                />
                            ))}
                            {chipsetClients.map((client, index) => (
                                <img
                                    key={`chipset-dup-${index}`}
                                    src={client.src}
                                    alt={client.alt}
                                    className="client-logo"
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Overview;